module.exports = __webpack_public_path__ + "img/happy--default.c1d66b17.svg";